exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#search{text-align:center}#search input{border:none;border-bottom:2px solid #f5f5f5;color:#2c3e50;font-size:2.5rem;padding:10px 10px 10px 5px;transition:border-bottom-color .25s;width:100%}#search input:focus{border-bottom-color:#dcdcdc;outline:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f972e08","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/search.vue
// module id = 21
// module chunks = 0